import { useEffect, useState } from "react";

import { type VideoStreamManifest } from "../../../../types";
import { type Stream } from "../utils/dashParser";
import { getSupportedStream } from "../utils/streamingUtils";

const useStreamingSettings = (manifests: VideoStreamManifest[]) => {
  const [settings, setSettings] = useState<Stream>();

  useEffect(() => {
    setSettings(getSupportedStream(manifests));
  }, [manifests]);

  return settings;
};

export default useStreamingSettings;
